module.exports = __webpack_public_path__ + "static/media/image-9.5c4aeb0d.png";